var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con-wrap"},[_c('List',{attrs:{"accountType":_vm.accountType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }